<template>
  <div>
    <ActionBar dismissible @dismiss="dismiss">
      <template #action>
        <el-button v-if="isAdmin && !isDeleted" type="danger" plain @click="del">
          ลบรายการนี้
        </el-button>
        <el-button v-if="isDeleted" type="danger" plain disabled>
          ถูกลบแล้ว
        </el-button>

        <el-button type="primary" @click="handlePrintButtonClick">
          พิมพ์ใบขายทอง
        </el-button>
      </template>
      <ActionBarTitle v-if="data">ขายทอง/{{ data.pos.displayId }}</ActionBarTitle>
    </ActionBar>

    <PageContainer v-if="data">
      <AppContainer>
        <el-card v-if="customer" header="รายละเอียดลูกค้า" style="marginBottom:1rem;">
          <ClientProfile :data="customer" readonly></ClientProfile>
        </el-card>

        <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap', marginBottom: '1rem', fontSize: '1rem' }">
          <el-col :sm="12" :md="16" :style="{ marginBottom: $mq === 'sm' ? '0.5rem' : null }">
            วันที่บันทึก : {{ data.lastUpdated | $_datetime_thaiDatetime }} เวลา
            {{ data.lastUpdated | $_datetime_thaiDatetime('H:mm') }}
          </el-col>
          <el-col :sm="12" :md="8">ผู้บันทึก : {{ data.user }}</el-col>
        </el-row>

        <el-card>
          <el-row type="flex" :gutter="16" :style="{
              flexWrap: 'wrap',
              marginBottom: '1.5rem',
              fontSize: '1rem',
              fontWeight: 'bold',
              alignItems: 'baseline'
            }">
            <el-col :sm="12" :md="16" :style="{ marginBottom: $mq === 'sm' ? '0.5rem' : null }">
              วันที่ขาย. {{ data.pos.date | $_datetime_thaiDatetime }}
            </el-col>
            <el-col :sm="12" :md="8">
              <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap', alignItems: 'baseline' }">
                <el-col :sm="12">เลขที่ใบรับประกัน</el-col>
                <el-col :sm="12" :style="{ fontSize: '1.125rem' }">
                  {{ data.pos.warrantyCardNo }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <StoreGold :items="data.pos.items" :discount="data.pos.discount" readonly :show-summary="false"
            :style="{ marginBottom: '1.5rem' }"></StoreGold>

          <el-form :style="{ marginBottom: '1.5rem' }">
            <el-form-item label="หมายเหตุ">
              <el-input :value="data.pos.note" type="textarea" :autosize="{ minRows: 3 }" readonly></el-input>
            </el-form-item>
          </el-form>

          <el-row type="flex">
            <el-col :sm="{ span: 16, offset: 4 }">
              <PanelBorderless :style="{ marginBottom: '1.5rem' }">
                <div slot="header"></div>
                <el-row type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    alignItems: 'baseline',
                    marginBottom: '0.5rem'
                  }">
                  <el-col :sm="16">รวมเป็นเงิน</el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{ data.payment.total | $_number_formattedNumber }}
                    ฿
                  </el-col>
                </el-row>
                <el-row type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    alignItems: 'baseline',
                    marginBottom: '0.5rem'
                  }">
                  <el-col :sm="16" :style="{ fontSize: '0.875rem' }">
                    ส่วนลด
                  </el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{ data.payment.discount | $_number_formattedNumber }} ฿
                  </el-col>
                </el-row>
                <el-row type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    fontWeight: 'bold',
                    alignItems: 'baseline',
                    marginBottom: '0.5rem'
                  }">
                  <el-col :sm="16">จำนวนเงินหลังหักส่วนลด</el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{
                    data.payment.totalWithDiscount | $_number_formattedNumber
                    }}
                    ฿
                  </el-col>
                </el-row>
              </PanelBorderless>

              <PanelBorderless :style="{ marginBottom: '1.5rem' }">
                <h2 slot="header" :style="{ fontSize: '1rem', margin: '0' }">
                  ช่องทางรับชำระ
                </h2>
                <el-row v-for="(method, index) in data.payment.methods" :key="index" type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    fontWeight: 'bold',
                    alignItems: 'baseline',
                    marginBottom: '1rem'
                  }">
                  <el-col :sm="16">
                    <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap' }">
                      <el-col :span="null" :style="{ flex: '0 1 3em' }">
                        {{ index + 1 }}.
                      </el-col>
                      <el-col :span="null" :style="{ flex: '1' }">
                        <div :style="{ marginBottom: '0.5rem' }">
                          {{ method.method.name }}
                          <span v-if="method.method.id !== 1" :style="{ fontWeight: 'normal' }">
                            ({{ method.method.bank }}
                            {{ method.method.accountId }})
                          </span>
                        </div>
                        <div v-if="method.method.id !== 1" :style="{ fontSize: '0.75rem', fontWeight: 'normal' }">
                          <el-row type="flex" :gutter="16" :style="{
                              flexWrap: 'wrap',
                              marginBottom: '0.25rem'
                            }">
                            <el-col :span="16">จำนวน</el-col>
                            <el-col :span="8" :style="{ textAlign: 'right' }">
                              {{ method.amount | $_number_formattedNumber }} บาท
                            </el-col>
                          </el-row>
                          <el-row type="flex" :gutter="16" :style="{
                              flexWrap: 'wrap',
                              marginBottom: '0.25rem'
                            }">
                            <el-col :span="16">
                              ค่าธรรมเนียม
                              {{ method.fee }}%
                            </el-col>
                            <el-col :span="8" :style="{ textAlign: 'right' }">
                              {{
                              method.calculatedFee | $_number_formattedNumber
                              }}
                              บาท
                            </el-col>
                          </el-row>
                          <div>รหัสอ้างอิง {{ method.ref }}</div>
                        </div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{ method.finalAmount | $_number_formattedNumber }} ฿
                  </el-col>
                </el-row>
                <hr />
                <el-row type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    alignItems: 'baseline',
                    marginBottom: '0.5rem',
                    fontSize: '1rem'
                  }">
                  <el-col :sm="16">รวมเงินที่รับชำระ</el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{
                    data.payment.totalReceivedAmount
                    | $_number_formattedNumber
                    }}
                    ฿
                  </el-col>
                </el-row>
                <hr />
                <el-row type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    alignItems: 'baseline',
                    marginBottom: '0.5rem',
                    fontSize: '1rem'
                  }">
                  <el-col :sm="16">จำนวนเงินหลังหักส่วนลด</el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{
                    data.payment.totalWithDiscount | $_number_formattedNumber
                    }}
                    ฿
                  </el-col>
                </el-row>
                <el-row type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    alignItems: 'baseline',
                    marginBottom: '0.5rem',
                    fontSize: '1rem'
                  }">
                  <el-col :sm="16">รวมค่าธรรมเนียม</el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{ data.payment.totalFee | $_number_formattedNumber }} ฿
                  </el-col>
                </el-row>
                <hr />
                <el-row type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    alignItems: 'baseline',
                    marginBottom: '0.5rem',
                    fontSize: '1.125rem',
                    fontWeight: 'bold'
                  }">
                  <el-col :sm="16">รวมที่ต้องชำระทั้งสิ้น</el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{
                    data.payment.totalPaidAmount | $_number_formattedNumber
                    }}
                    ฿
                  </el-col>
                </el-row>
                <hr />
                <hr />
                <el-row type="flex" :gutter="16" :style="{
                    flexWrap: 'wrap',
                    alignItems: 'baseline',
                    marginBottom: '0.5rem',
                    fontSize: '1rem'
                  }">
                  <el-col :sm="16">เงินทอน</el-col>
                  <el-col :sm="8" :style="{ textAlign: 'right' }">
                    {{ data.payment.change | $_number_formattedNumber }} ฿
                  </el-col>
                </el-row>
              </PanelBorderless>

              <PanelBorderless>
                <h2 slot="header" :style="{ fontSize: '1rem', margin: '0' }">
                  หลักฐาน/สลิป
                </h2>
                <FilePreviewList>
                  <FilePreviewListItem v-for="(item, index) in data.evidences" :key="index">
                    <FilePreview :src="item.url" :style="{ width: '150px', height: '150px' }" :removable="false">
                    </FilePreview>
                  </FilePreviewListItem>
                </FilePreviewList>
              </PanelBorderless>
            </el-col>
          </el-row>
        </el-card>
      </AppContainer>
    </PageContainer>
  </div>
</template>

<script>
import { numberMixin, datetimeMixin } from '@/mixins'
import {
  ActionBar,
  //ActionBarButton,
  ActionBarTitle
} from '@/components/ui/action-bar'
import { AppContainer } from '@/components/ui/container'
import { PageContainer } from '@/components/page/page-container'
import { ClientProfile } from '@/components/page/client-profile'
import { PanelBorderless } from '@/components/page/panel-borderless'
import {
  FilePreview,
  FilePreviewList,
  FilePreviewListItem
} from '@/components/page/file-preview'
import { StoreGold } from '@/components/page/store-gold'
import { useLoading } from '@/use/loading'
import { SellReceiptService } from '@/services'
import { useCustomer } from '@/use/customer'
import { useSellItem, useSellProduct } from '@/use/sell'
import { usePaymentMethod, usePaymentMethodMethod } from '@/use/payment'
import { useEvidence } from '@/use/evidence'
import { back } from '@/utils/navigation'
import { mapGetters } from 'vuex'

export default {
  components: {
    ActionBar,
    //ActionBarButton,
    ActionBarTitle,
    AppContainer,
    PageContainer,
    ClientProfile,
    PanelBorderless,
    FilePreview,
    FilePreviewList,
    FilePreviewListItem,
    StoreGold
  },

  mixins: [numberMixin, datetimeMixin],

  data() {
    return {
      customer: null,
      data: null
    }
  },

  computed: {
    ...mapGetters('auth', ['isAdmin']),

    isDeleted() {
      return this.data && !!this.data.deleted
    }
  },

  async created() {
    const loading = useLoading()

    try {
      await this.load()
    } catch (err) {
      this.$notify.error(err.message)
    } finally {
      loading.close()
    }
  },

  methods: {
    async load() {
      const { id } = this.$route.params

      const {
        data: { status, result }
      } = await SellReceiptService.get(id)

      if (status === 'error')
        throw new Error('ไม่สามารถรับข้อมูลการขายทองนี้ได้')

      if (result.trade_pos) {
        return this.$router.replace({
          name: 'TradeDetail',
          params: { type: 'sell', id: this.$route.params.id }
        })
      }

      this.customer = result.customer
        ? useCustomer({
            id: result.customer.id,
            avatar: result.customer.image.medium,
            firstName: result.customer.full_name,
            tel: result.customer.phone
          })
        : null

      const pos = {
        date: new Date(result.pos.datetime),
        displayId: result.pos.display_id,
        warrantyCardNo: result.pos.insurance_number,
        discount: +result.pos.commission_discount_percentage / 100,
        items: result.pos.items.map(item =>
          useSellItem({
            product: useSellProduct({
              id: item.product.id,
              name: item.product.name,
              type: { 1: 'ingot', 2: 'ornament' }[item.product.ref_price.id],
              percent: +item.product.purity_percentage / 100,
              price: +item.product.gold_price.sell_price,
              weight: +item.product.baht_weight
            }),
            goldPattern: item.gold_pattern,
            weight: +item.baht_weight,
            realWeight: +item.real_weight,
            price: +item.final_price,
            charge: +item.commission
          })
        ),
        note: result.pos.note
      }

      this.data = {
        lastUpdated: new Date(result.last_updated),
        deleted: result.deleted ? new Date(result.deleted) : undefined,
        user:
          result.user &&
          `${result.user.first_name} ${result.user.last_name}`.trim(),
        pos,
        payment: {
          total: pos.items.reduce(
            (prev, curr) => prev + curr.total(pos.discount),
            0
          ),
          discount: +result.discount,
          get totalWithDiscount() {
            return this.total - this.discount
          },
          methods: result.payments.map(item => {
            const { payment_method } = item

            return usePaymentMethod({
              method: usePaymentMethodMethod({
                id: payment_method.id,
                name: payment_method.account_name,
                bank: payment_method.bank && payment_method.bank.name,
                accountId: payment_method.bank_account_id,
                isFeeFree: !payment_method.has_fee
              }),
              ref: item.ref,
              fee: +item.fee_percentage,
              amount: +item.amount
            })
          }),
          get totalReceivedAmount() {
            return this.methods.reduce(
              (prev, curr) => prev + curr.finalAmount,
              0
            )
          },
          get totalFee() {
            return this.methods.reduce(
              (prev, curr) => prev + curr.calculatedFee,
              0
            )
          },
          get totalPaidAmount() {
            return this.totalWithDiscount + this.totalFee
          },
          get change() {
            return this.totalReceivedAmount - this.totalPaidAmount
          }
        },
        evidences: result.attachments.map(item =>
          useEvidence({ id: item.id, url: item.attachment })
        )
      }
    },

    del() {
      this.$confirm('ต้องการที่จะลบรายการหรือไม่', 'ยืนยันการลบรายการ', {
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ไม่',
        type: 'warning'
      }).then(() => {
        const loading = useLoading()

        SellReceiptService.del(this.$route.params.id)
          .then(res => res.data)
          .then(({ status }) => {
            loading.close()

            if (status === 'error')
              throw new Error('เกิดข้อผิดพลาดในการลบรายการ')

            this.$notify.success('ลบรายการเรียบร้อย')

            back({ name: 'History' })
          })
          .catch(err => {
            this.$notify.error(err.message)
          })
      })
    },

    dismiss() {
      back({ name: 'History' })
    },

    handlePrintButtonClick() {
      console.log('test')

      const route = this.$router.resolve({
        name: 'SellPrint',
        params: this.$route.params
      })

      window.open(route.href)
    }
  }
}
</script>
